const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/income/api-factory');
const serviceFactory = require('../resources/income/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/netincomehistory/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app

    .match(`${p}income.overview[{keys:portfolioId}][{keys:startDate}][{keys:endDate}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getIncomeOverviewData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}income.overviewForLUX[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getIncomeOverviewLUXData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
    )))

    .match(`${p}income.transactionlist[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:prodType}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getIncomeTransactionList(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}income.transactionlist.ch[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:prodType}][{keys:ieFlag}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getCHIncomeTransactionList(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}income.transactionlist.ch[{integers:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:prodType}][{keys:ieFlag}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getCHIncomeTransactionList(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )));
    // .match(`${p}income.overviewchdata[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:selLanguageCode}]`, requests => Promise.all(
    //   requests.map(({ req, res }) =>
    //     service.getIncomeOverviewCHData(req.params)
    //       .then(response => res.value(response))
    //       .catch(res.error)
    //   )));
}

module.exports = addRoutes;
